import { Component, OnInit } from '@angular/core';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';

@Component({
  selector: 'app-access-restricted',
  templateUrl: './access-restricted.component.html',
  styleUrls: ['./access-restricted.component.scss'],
})
export class AccessRestrictedComponent implements OnInit {
  hotelURL: string;
  constructor(public AppInitializer: LegacyBookInitService) {}

  ngOnInit() {
    this.hotelURL = this.AppInitializer.PropertyData.UrlMap.CustomerWebsiteUrl;
    var preloader = document.querySelector('.preloaderapp');
    if (preloader) {
      preloader.className = ' preloaderapp-hidden-add preloaderapp-hidden-add-active';
    }
    let urlimg = 'url(https://rguestbookdev.blob.core.windows.net/wbe/395/alpha/images/404-auth.svg) no-repeat center center fixed';
    $('html').css('background', urlimg);
    $('html').css('-webkit-background-size', 'cover');
    $('html').css('-moz-background-size', 'cover');
    $('html').css('-o-background-size', 'cover');
    $('html').css('background-size', 'contain');
    $('body').css('background-color', 'unset');
    $('html').css('background-color', '#f1f3f2');
  }
}
